/* PAX buy box — Version B, built for real.
 *
 * Owns the INTERFACE only. Super Subscriptions is the engine: its Function prices the pack
 * discount and it owns the selling plans and recurring billing.
 *
 * NOTHING ABOUT PRICING IS HARDCODED. Pack sizes and pack prices are read from the app's own
 * (hidden) block at runtime via data-tier-quantity / data-price-type / data-price-value
 * (full | fixed | amount_off). Subscription prices and cadences come from the selling plans
 * via pax-bb-data. Change either and this follows.
 *
 * The app's Function keys on LINE ITEM PROPERTIES — see pax-buybox-props.js. Without them a
 * ONE-TIME pack is charged at full price.
 *
 * SUBSCRIPTION lines are deliberately sent WITHOUT those properties, and that is not an
 * oversight. A subscription is priced by its SELLING PLAN, whose pricing policy is a fixed
 * amount off each unit (-$4.60 monthly, -$5.75 bimonthly) applied by Shopify whenever the
 * selling_plan is attached, with no reference to the properties. Tagging a subscription line
 * therefore buys no discount, and it costs the customer the ability to ever change flavours:
 * Super Subscriptions locks a bundle-tagged line, so the portal will not swap, requantify or
 * remove it, and its Remove reports success while doing nothing. Verified in TEST_PLAN.md,
 * test 5. Do not re-add the properties to subscription lines without re-running that test.
 *
 * SAVINGS ARE ON A DELIVERED BASIS against "one tin at a time" (unit + shipping). That is the
 * only honest baseline: this module sells 1, 3 or 6, so a customer who wants three tins cannot
 * order three singles — their real alternative is one tin, three separate times, paying
 * shipping each time. The basis is printed under the rows and must stay there. */
(function () {
  'use strict';
  var root = document.querySelector('[data-pax-buybox]');
  if (!root) return;

  var DATA;
  try { DATA = JSON.parse(document.getElementById('pax-bb-data').textContent); }
  catch (e) { return; }

  var F = DATA.flavours, UNIT = DATA.unit, SHIP = DATA.ship, FREE_FROM = DATA.freeFrom;
  var POUCHES = DATA.pouchesPerTin || 20;
  var COPY = DATA.copy || {};
  var PLANS = DATA.plans || [];
  var PLAN_MONTHS = DATA.planMonthsForPack || {};
  var BASE = UNIT + SHIP;                    /* one tin, delivered — the baseline */

  /* Which plan serves a given pack size. Returns null when no plan matches, and every caller
     treats null as "this pack cannot be subscribed to" rather than falling back to any plan.
     The old code used selling_plans.first for every pack, which would have put a 6-tin
     subscriber on the monthly plan at the wrong price. */
  function planFor(n) {
    var want = PLAN_MONTHS[String(n)];
    if (!want) return null;
    for (var i = 0; i < PLANS.length; i++) {
      if (PLANS[i].months === want) return PLANS[i];
    }
    return null;
  }

  function readPacks() {
    var app = document.querySelector('[data-bundle-block-id]');
    if (!app) return null;
    var tiers = app.querySelectorAll('.sss-bundle-block__tier');
    if (!tiers.length) return null;
    var out = [], def = null;
    Array.prototype.forEach.call(tiers, function (t) {
      var n = parseInt(t.dataset.tierQuantity, 10);
      if (!n) return;
      var type = t.dataset.priceType, val = parseFloat(t.dataset.priceValue) || 0, price;
      if (type === 'fixed') price = val;
      else if (type === 'amount_off') price = n * (UNIT - val);
      else price = n * UNIT;
      var c = COPY[String(n)] || {};
      var pl = planFor(n);
      out.push({
        n: n, price: price,
        plan: pl, sub: pl ? n * pl.perTin : null,
        label: c.label || t.dataset.tierTitle,
        badge: c.badge || null, badgeClass: c.badgeClass || '', extra: c.extra || null
      });
      var inp = t.querySelector('input[type="radio"]');
      if (inp && inp.checked) def = n;
    });
    out.sort(function (a, b) { return a.n - b.n; });
    return { packs: out, def: def || (out[0] && out[0].n) };
  }

  var PACKS = null;
  var need = 0, chosen = [], mode = 'sub', noteOn = false;

  var $ = function (s) { return root.querySelector(s); };
  var money = function (n) { return '$' + n.toFixed(2); };
  var pack = function () { return PACKS.filter(function (p) { return p.n === need; })[0]; };
  var anySub = function () { return PACKS.some(function (p) { return p.sub != null; }); };
  var subbing = function () { return mode === 'sub' && pack().sub != null; };
  var priceOf = function (p) { return (mode === 'sub' && p.sub != null) ? p.sub : p.price; };
  var count = function (i) { return chosen.filter(function (x) { return x === i; }).length; };
  var isAll = function () { return need === F.length && need === PACKS[PACKS.length - 1].n; };
  var total = function () { return priceOf(pack()); };

  /* Subscriptions always ship free; one-time ships free from the threshold. */
  var shipsFree = function (p) { return (mode === 'sub' && p.sub != null) || p.price >= FREE_FROM; };
  var delivered = function (p) { return priceOf(p) + (shipsFree(p) ? 0 : SHIP); };
  var saveOn = function (p) { var s = p.n * BASE - delivered(p); return s > 0.005 ? s : 0; };
  var centsPerPouch = function (p) { return Math.round(priceOf(p) * 100 / (p.n * POUCHES)); };
  /* The FLOOR across every pack and plan — what "From Xc a pouch" must mean. Multiply by 100
     before dividing, or 14.90/20 lands on 74.4999 and rounds down a cent. */
  var cheapestCents = function () {
    return Math.round(Math.min.apply(null, PACKS.map(function (p) {
      return (p.sub != null ? p.sub : p.price) * 100 / (p.n * POUCHES);
    })));
  };
  var everyText = function (m) { return m === 1 ? 'every month' : 'every ' + m + ' months'; };
  /* Headline subscription discount. Floored, never rounded up, so the claim can only ever
     understate what the customer actually gets. Derived from the live prices for the same
     reason everything else here is: a typed "15%" survives a price change and becomes a lie. */
  var maxSubPct = function () {
    var best = 0;
    PACKS.forEach(function (p) {
      if (p.sub == null || !p.price) return;
      var pct = (p.price - p.sub) / p.price * 100;
      if (pct > best) best = pct;
    });
    return Math.floor(best);
  };
  /* "Full price" was only ever true of the single tin, yet it sat on the box that also sells
     the 3 and the 6 -- both of which are discounted one-time. Derived, like everything else
     here, so it cannot go stale the next time the tiers move. */
  var discountedPackNs = function () {
    return PACKS.filter(function (p) { return p.n > 1 && p.price < (p.n * UNIT) - 0.005; })
                .map(function (p) { return p.n; });
  };
  var oneTimeSubLabel = function () {
    var ns = discountedPackNs();
    if (!ns.length) return 'Buy once, no subscription';
    var list = ns.length === 1 ? ns[0] + '-tin pack'
             : ns.slice(0, -1).join(', ') + ' and ' + ns[ns.length - 1] + ' packs';
    return 'No subscription. ' + list + ' still discounted.';
  };

  /* The mock spells the flavour count. Derived, so it cannot contradict the actual range. */
  var WORDS = ['zero','one','two','three','four','five','six','seven','eight','nine','ten'];
  var numWord = function (n) { return WORDS[n] || String(n); };

  function drawToggle() {
    var box = $('.pax-bb__toggle');
    if (!anySub()) { box.parentNode.style.display = 'none'; return; }
    box.parentNode.style.display = '';
    box.innerHTML =
      '<div class="pax-bb__tg' + (mode === 'sub' ? ' on' : '') + '" data-mode="sub">' +
        '<b>Subscribe and save</b><em>' +
          (maxSubPct() > 0 ? 'Up to ' + maxSubPct() + '% off, s' : 'S') + 'kip or cancel anytime</em>' +
        '<span class="pax-bb__shipnote">Always free shipping</span></div>' +
      '<div class="pax-bb__tg' + (mode === 'one' ? ' on' : '') + '" data-mode="one">' +
        '<b>One time</b><em>' + oneTimeSubLabel() + '</em></div>';
  }

  function drawRows() {
    $('.pax-bb__rows').innerHTML = PACKS.map(function (p) {
      var showSub = mode === 'sub' && p.sub != null;
      var bens = [];
      if (saveOn(p)) bens.push('Save ' + money(saveOn(p)));
      if (shipsFree(p)) bens.push('Free shipping');   /* a cost is not a benefit — the single
                          tin's shipping sits under its price instead */
      if (p.extra) bens.push(p.extra);
      /* The coffee comparison rides only on the packs. At the single tin's per-pouch rate it
         is nearer an eighth of a cafe coffee, the one place a customer could argue it. */
      bens.push(centsPerPouch(p) + 'c a pouch' + (p.n === 1 ? '' : ', about a tenth of a cafe coffee'));
      if (showSub) bens.push('Delivered ' + everyText(p.plan.months) + ', skip or cancel anytime');
      bens.push('30-day money-back guarantee');

      return '<div class="pax-bb__row' + (p.n === need ? ' on' : '') + '" data-n="' + p.n + '">' +
        (p.badge ? '<span class="pax-bb__rbadge' + p.badgeClass + '">' + p.badge + '</span>' : '') +
        '<div class="pax-bb__rhead">' +
          '<span class="pax-bb__radio"></span>' +
          '<span><span class="pax-bb__rt">' + p.label + '</span>' +
            '<span class="pax-bb__rs">' + (p.n * POUCHES) + ' pouches &middot; ' +
              (p.n * POUCHES / 2) + '-day supply</span></span>' +
          '<span class="pax-bb__rp"><b>' + money(priceOf(p)) + '</b>' +
            (saveOn(p) ? '<s>' + money(p.n * BASE) + '</s>' : '') +
            (showSub ? '<i>per ' + (p.plan.months === 1 ? 'month' : p.plan.months + ' months') + '</i>'
                     : (shipsFree(p) ? '' : '<i class="pax-bb__shipcost">+ ' + money(SHIP) + ' shipping</i>')) +
          '</span>' +
        '</div>' +
        '<ul class="pax-bb__rbens">' +
          bens.map(function (b) { return '<li>' + b + '</li>'; }).join('') +
        '</ul></div>';
    }).join('');
    $('.pax-bb__basis').textContent =
      'Savings compared with buying one tin at a time — ' + money(UNIT) +
      ' plus ' + money(SHIP) + ' shipping, every time.';
  }

  function drawFlavours() {
    var all = isAll();
    $('.pax-bb__flavs').innerHTML = F.map(function (f, i) {
      var n = all ? 1 : count(i);
      var out = f.available === false;
      return '<div class="pax-bb__f' + (n > 0 && !out ? ' on' : '') + (out ? ' out' : '') +
        '" data-i="' + i + '"' + (out ? ' aria-disabled="true"' : '') + '>' +
        '<span class="pax-bb__tick">' + (n > 1 ? '×' + n : '✓') + '</span>' +
        (all ? '' : '<span class="pax-bb__minus" data-rm="' + i + '">−</span>') +
        (f.mark
          ? '<img class="pax-bb__mark" src="' + f.mark + '" alt="" width="26" height="26" ' +
            'onerror="this.outerHTML=\'<span class=&quot;pax-bb__dot&quot; ' +
            'style=&quot;background:' + f.colour + '&quot;></span>\'">'
          : '<span class="pax-bb__dot" style="background:' + f.colour + '"></span>') +
        '<small>' + f.title + (out ? '<em>Sold out</em>' : '') + '</small></div>';
    }).join('');
  }

  function draw() {
    var all = isAll();
    /* STOCK WAS NEVER CONSULTED HERE until 2026-08-08. A sold-out flavour stayed selectable,
       the CTA stayed live, and /cart/add.js rejected the line silently - empty cart, no
       message, customer gone. Worst on the all-flavours pack, where ONE missing flavour killed
       the whole add. Six flavours never depleting evenly, this was the normal state, not an
       edge case. */
    var allAvail = F.every(function (f) { return f.available !== false; });
    var pickedOk = chosen.every(function (i) { return F[i] && F[i].available !== false; });
    var done = all ? allAvail : (chosen.length === need && pickedOk);
    drawToggle(); drawRows(); drawFlavours();
    var bp = $('.pax-bb__ben-price b');
    if (bp) bp.textContent = cheapestCents() + 'c';
    var note = $('.pax-bb__note');
    note.textContent = 'Single tins are one-time purchases. Subscribe from 3 tins.';
    note.className = 'pax-bb__note' + (noteOn ? ' on' : '');
    $('.pax-bb__fl').textContent = all
      ? 'All ' + numWord(F.length) + ' flavours included'
      : 'Pick your ' + need + ' flavour' + (need > 1 ? 's' : '');
    var c = $('.pax-bb__count');
    c.textContent = all ? 'One of each, ready to go' : chosen.length + ' of ' + need + ' chosen';
    c.className = 'pax-bb__count' + (done ? ' done' : '');
    $('.pax-bb__hint').style.display = (need === 1 || all) ? 'none' : 'block';
    var b = $('.pax-bb__cta');
    b.disabled = !done;
    if (done) {
      b.textContent = (subbing() ? 'Start subscription' : 'Add to cart') + ' · ' + money(total());
    } else if (!allAvail && (all || !pickedOk)) {
      /* say WHY it is blocked. The whole fault being fixed was silence. */
      b.textContent = F.every(function (f) { return f.available === false; })
        ? 'Out of stock'
        : 'Some flavours are sold out';
    } else {
      b.textContent = 'Pick ' + (need - chosen.length) + ' more flavour' +
        ((need - chosen.length) > 1 ? 's' : '');
    }
  }

  root.addEventListener('click', function (e) {
    if (!PACKS) return;
    var rm = e.target.closest('[data-rm]');
    if (rm) {
      e.stopPropagation();
      var k = chosen.lastIndexOf(+rm.dataset.rm);
      if (k > -1) chosen.splice(k, 1);
      draw(); return;
    }
    var f = e.target.closest('.pax-bb__f');
    if (f) {
      var fi = +f.dataset.i;
      /* A sold-out flavour cannot be chosen. Guarded here AS WELL AS in CSS: pointer-events is
         a presentation rule, and this has to hold if the stylesheet fails to load. */
      if (F[fi] && F[fi].available === false) return;
      if (!isAll() && chosen.length < need) chosen.push(fi);
      draw(); return;
    }
    var r = e.target.closest('.pax-bb__row');
    if (r) {
      need = +r.dataset.n; chosen = []; noteOn = false;
      /* The only place this module overrides the customer — and it must never be silent. */
      if (pack().sub == null && mode === 'sub') { mode = 'one'; noteOn = true; }
      draw(); return;
    }
    var tg = e.target.closest('.pax-bb__tg');
    if (tg) {
      mode = tg.dataset.mode; noteOn = false;
      if (mode === 'sub' && pack().sub == null) {
        var first = PACKS.filter(function (p) { return p.sub != null; })[0];
        if (first) { need = first.n; chosen = []; noteOn = true; }
      }
      draw(); return;
    }
  });

  var busy = false;
  /* DELEGATED, not bound to the button. FOUND 2026-09-06: about 0.4 s after load the Super
     Subscriptions app rewrites .pax-bb__panel to inject its discount badge, which REPLACES the CTA
     with a copy. A listener attached to the original button was silently lost — click, nothing,
     no error. The flavour tiles never broke because they were already delegated on root. So:
     nothing inside the panel may hold a direct listener; match on the way up instead. */
  root.addEventListener('click', function (e) {
    var btn = e.target.closest('.pax-bb__cta');
    if (!btn) return;
    if (btn.disabled || busy || !PACKS) return;   /* busy guards against a double add */
    busy = true;
    var list = isAll() ? F.map(function (_, i) { return i; }) : chosen;
    var plan = subbing() ? Number(pack().plan.id) : null;
    /* ONE-TIME LINES ONLY. The bundle properties are what the pack discount Function keys off,
       so a one-time 3-pack needs them. A subscription does not: its price comes from the selling
       plan, a fixed amount off each unit, tag or no tag. Worse, the app treats a bundle-tagged line
       as locked — the customer portal will not swap, requantify or remove it, and a Remove even
       reports success while doing nothing. Tagging a subscription line buys no discount and
       freezes the flavours for life. See TEST_PLAN.md, test 5. */
    var props = (!plan && typeof window.paxBundleProps === 'function') ? window.paxBundleProps(need) : null;
    var items = list.map(function (i) {
      var it = { id: Number(F[i].id), quantity: 1 };
      if (plan) it.selling_plan = plan;
      if (props) it.properties = props;
      return it;
    });
    var drawer = document.querySelector('cart-drawer');
    var secs = 'cart-drawer,cart-icon-bubble';
    try { secs = drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','); } catch (e) {}
    /* Instant feedback. The add itself takes ~0.85 s on Shopify's side (cart processing plus the
       subscription app's pricing function), ~1.5 s to an open drawer. Measured 2026-09-06. With
       the button unchanged for that long, people read it as "nothing happened" and click again. */
    var label = btn.textContent;
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = 'Adding\u2026';
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items, sections: secs, sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); })
      .then(function (j) {
        if (!drawer) { window.location = '/cart'; return; }
        try {
          if (j.sections) drawer.renderContents(j);
          if (window.paxRefreshDrawer) window.paxRefreshDrawer(drawer);
          if (drawer.open) drawer.open();
        } catch (e) { window.location = '/cart'; }
      })
      .catch(function () { window.location = '/cart'; })
      .then(function () { btn.removeAttribute('aria-busy'); btn.textContent = label; busy = false; });
  });

  /* Returning from checkout restores the page from bfcache with a stale drawer, which then
     reads as an empty cart. Re-sync on every show, not just first load. */
  window.addEventListener('pageshow', function () {
    if (window.paxRefreshDrawer) window.paxRefreshDrawer(document.querySelector('cart-drawer'));
  });

  /* ONE PDP, SEVERAL ENTRY POINTS. The home page offer cards all land here, each naming the
     pack the customer just clicked: ?pack=3&plan=sub. Without this they would arrive on the
     default pack and have to re-choose what they already chose. Anything unrecognised is
     ignored and the app's own default stands — a bad URL must never blank the buy box. */
  function fromUrl(packs) {
    var q = {};
    try {
      new URLSearchParams(window.location.search).forEach(function (v, k) { q[k.toLowerCase()] = v; });
    } catch (e) { return null; }
    var n = parseInt(q.pack, 10);
    var valid = packs.some(function (p) { return p.n === n; });
    return { n: valid ? n : null, mode: (q.plan === 'sub' || q.plan === 'one') ? q.plan : null };
  }

  /* The app builds its tiers asynchronously; reading them at script time found nothing and
     bailed permanently, leaving the buy box blank. Wait for them. */
  function init() {
    var read = readPacks();
    if (!read || !read.packs.length) return false;
    PACKS = read.packs;
    var url = fromUrl(read.packs) || {};
    need = url.n || read.def;
    if (url.mode) mode = url.mode;
    if (!anySub()) mode = 'one';
    if (pack().sub == null && mode === 'sub') mode = 'one';
    draw();
    return true;
  }
  if (!init()) {
    var tries = 0;
    var iv = setInterval(function () { if (init() || ++tries > 60) clearInterval(iv); }, 100);
  }
})();
